import { ApiResponse } from "@/utils/ApiResponse";
import { CategoriasProductoInterface } from "../../interfaces/categoriaInterfaces/CategoriasProducto.interface";
import apiClient from "@/clients/apiClient";
import { CategoriaCreateInterface } from "../../interfaces/categoriaInterfaces/CategoriaCreate.interface";

export async function CategoriaProductoCreateAction(
  categoria: CategoriaCreateInterface
): Promise<ApiResponse<CategoriasProductoInterface>> {
  const { data } = await apiClient.post<CategoriasProductoInterface>(
    "/gpCategoriasProducto",
    categoria
  );
  return {
    status: 200,
    data,
    message: "Categoría de producto creada correctamente",
  };
}
